/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AccountProviderService } from './services/account-provider.service';
import { AdsService } from './services/ads.service';
import { CheckoutExtensionService } from './services/checkout-extension.service';
import { CompetitionsService } from './services/competitions.service';
import { IndexService } from './services/index.service';
import { LegacyService } from './services/legacy.service';
import { MarketingService } from './services/marketing.service';
import { MarketingOptService } from './services/marketing-opt.service';
import { WhereToShopService } from './services/where-to-shop.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AccountProviderService,
    AdsService,
    CheckoutExtensionService,
    CompetitionsService,
    IndexService,
    LegacyService,
    MarketingService,
    MarketingOptService,
    WhereToShopService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
